module.exports = __webpack_public_path__ + "img/karriere-marketplaces.129d99d9.jpg";